/**
 * @generated SignedSource<<a2755ac33d8af2fc8a9a042570dfab05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
export type IssueFieldDataType = "DATE" | "NUMBER" | "SINGLE_SELECT" | "TEXT" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type IssueFieldPickerIssueField$data = {
  readonly dataType?: IssueFieldDataType;
  readonly databaseId?: number | null | undefined;
  readonly description?: string | null | undefined;
  readonly id?: string;
  readonly name?: string;
  readonly " $fragmentType": "IssueFieldPickerIssueField";
};
export type IssueFieldPickerIssueField$key = {
  readonly " $data"?: IssueFieldPickerIssueField$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueFieldPickerIssueField">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "IssueFieldPickerIssueField"
};

(node as any).hash = "31d854fea63dea594c796cfb9821b91c";

export default node;
